/**
 * @fileoverview Utilities to handle Enterprise used as a WebView in Voyager
 */
import { NextRouter } from 'next/router';
import { createContext, useContext, useEffect } from 'react';

const EmbeddedContext = createContext(false);

export const EmbeddedProvider = EmbeddedContext.Provider;

export const getIsEmbedded = (router: NextRouter) =>
  router?.query?.from === 'app' || router?.query?.mode === 'app';

export const useIsEmbedded = () => {
  const isEmbedded = useContext(EmbeddedContext);
  return isEmbedded;
};

export const useNativeCommunication = ({
  saveState,
  networkActive,
}: {
  saveState: boolean;
  networkActive: boolean;
}) => {
  const isEmbedded = useIsEmbedded();
  const sendNativeMessage = getSendNativeMessage();
  useEffect(() => {
    if (!isEmbedded || !sendNativeMessage) {
      return;
    }

    if (saveState) {
      sendNativeMessage('SAVE_STATE');
    } else {
      sendNativeMessage('DISCARD_STATE');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveState, isEmbedded]);

  useEffect(() => {
    if (!isEmbedded || !sendNativeMessage) {
      return;
    }

    if (networkActive) {
      sendNativeMessage('NETWORK_ACTIVE');
    } else {
      sendNativeMessage('NETWORK_INACTIVE');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkActive, isEmbedded]);
};

const getSendNativeMessage = () => (data: unknown) =>
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'ReactNativeWebView' does not exist on ty... Remove this comment to see the full error message
  /** @type window & {ReactNativeWebView: {postMessage: (message: string)=> void}} */ window?.ReactNativeWebView?.postMessage(
    data,
  );
